// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2tZV6","bigColWidth":"Table_bigColWidth__Q27VU","biggerColWidth":"Table_biggerColWidth__1-cOj","row":"Table_row__8OtvS","col":"Table_col__1REdS"};